import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody52';
import FooterNew from '../component/FooterNew';
import { Helmet } from 'react-helmet';

const CaseStudy52 = ({setBlank}) => {
     
    const headings = "<h4>HR Document</h4><h2 style='display:inline-block;color:#ffffff;transform:scale(0.85);transform-origin:left;'>Automation Platform</h2>";

  return (
    <>
        <Helmet>
        <title>HR Document Automation Platform</title>
        <meta property="og:title" content="HR Document Automation Platform" />
        <meta property='og:description' content='HR Document Automation Platform'/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy51" headings={headings} />  
        <Casestudybody />
        <FooterNew setBlank={setBlank} />
    </>
  )
}

export default CaseStudy52
